import {
  format,
  isAfter,
  setHours,
  setMinutes,
  addMinutes
} from 'date-fns'
import { convertToTimeZone } from 'date-fns-timezone'

export default {
  hasFinished: (state, getters) => (event) => {
    let timezone = event.get('timezone')
    if (!timezone) {
      timezone = 'Asia/Tokyo'
    }
    let date = convertToTimeZone(new Date(), { timeZone: timezone })
    return isAfter(date, getters.endDate(event))
  },

  startDate: () => (event) => {
    let date = event.get('date')
    const finish = event.get('start').split(':')
    date = setHours(date, finish[0])
    date = setMinutes(date, finish[1])
    return date
  },

  endDate: () => (event) => {
    let date = event.get('date')
    const finish = event.get('finish').split(':')
    date = setHours(date, finish[0])
    date = setMinutes(date, finish[1])
    return date
  },

  playingTime: (state, getters) => {
    const start = getters.startDate(state.playing)
    const end = getters.endDate(state.playing)
    return {
      start: format(start, 'H:mm'),
      end: format(end, 'H:mm')
    }
  },

  answerTime: (state, getters) => {
    const start = getters.startDate(state.playing)
    const end = getters.endDate(state.playing)
    const closeTime = addMinutes(end, state.playing.get('closeTime'))
    return {
      start: format(start, 'H:mm'),
      end: format(closeTime, 'H:mm')
    }
  },

  isStarted: (state) => {
    return state.playing
  },

  withinAnswerTime: (state) => {
    return state.status === 'eventIsAnswerTime'
  },

  pointCheckable: (state, getters, rootState) => {
    return getters.isStarted && !getters.withinAnswerTime && !rootState.answer.submit
  }
}
